import mitt from 'mitt';
export const Events = {
    submitAmount: 'submit-amount',
    submitPayment: 'submit-payment',
    checkOrder: 'check-order'
};
const emitter = mitt();
export const EventBus = emitter;
